import { IMultipleChoiceQuestionView } from '../../store/survey/surveyTypes';
import { stringToColour } from './colors';

export const getDistinctiveColor = (
  question: IMultipleChoiceQuestionView,
  status: any,
  currentScore: number
) => {
  let maxScore = 0;
  if (status) {
    for (const item in status) {
      maxScore = Math.max(status[item], maxScore);
    }
  }
  return stringToColour(
    question.title,
    1,
    null,
    undefined,
    currentScore,
    maxScore || 1,
    undefined,
    undefined,
    true
  );
};
